/**
 * Subscription Renewal Trigger Component
 *
 * Trigger: "a subscription renewal"
 * Shows: Stripe plan select (optional)
 */

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TriggerComponentProps } from '../automationTriggers';
import { StripePlanFields } from '../components/StripePlanFields';

export const SubscriptionRenewalTrigger: FC<TriggerComponentProps> = ({
  automation,
  index,
  readOnly,
}) => {
  const { t } = useTranslation();

  if (readOnly) {
    const planName = automation.stripePlan?.nickname;
    if (planName) {
      return <span>{t('automations.triggers.subscriptionRenewalFor', { plan: planName })}</span>;
    }
    return <span>{t('automations.triggers.subscriptionRenewal')}</span>;
  }

  // Edit mode - show stripe plan selection
  return <StripePlanFields automation={automation} index={index} />;
};
